import { IconButton } from "@similarweb/ui-components";
import styled from "styled-components";

import type { FC } from "react";
import { i18nFilter } from "app/filters/i18nFilter";

const ReactIconButtonWrapper = styled.div`
    position: relative;
`;

export const ReactIconButton: FC<any> = (props) => {
    const definedProps = {
        type: "flat",
        ...props,
    };
    const label = i18nFilter()(definedProps.text);

    return (
        <div data-automation={definedProps.iconName}>
            <ReactIconButtonWrapper>
                <IconButton {...definedProps}>{label}</IconButton>
            </ReactIconButtonWrapper>
        </div>
    );
};

